import React from "react";
import { ICommonIconProps } from "../interface/index";

const ArrowIcon = ({ ...props }: ICommonIconProps) => {
  return (
    <svg
      width={props?.IconWidth || "10"}
      height={props?.IconHeight || "7"}
      viewBox="0 0 10 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.06501 0.838998L9.86001 1.63475L5.52726 5.969C5.45783 6.03886 5.37527 6.09431 5.28434 6.13215C5.1934 6.16998 5.09588 6.18946 4.99738 6.18946C4.89889 6.18946 4.80137 6.16998 4.71043 6.13215C4.61949 6.09431 4.53693 6.03886 4.46751 5.969L0.132507 1.63475L0.927507 0.839747L4.99626 4.90775L9.06501 0.838998Z"
        fill={props?.IconColor || "currentColor"}
      />
    </svg>
  );
};

export default ArrowIcon;
